import { ICategoryCommission } from '@/models/commission.model';
import { CommissionCategoryTree } from '../../components';

type TCommissionCategoriesTabContainer = {
  categories: ICategoryCommission[];
  editedValues: Record<string, number>;
  onCommissionChange: (categoryId: string, value: number | null) => void;
  canManage: boolean;
  isLoading: boolean;
  selectedId: string | null;
  forcedOpenIds: Set<string>;
  onSelect: (categoryId: string) => void;
};

const CommissionCategoriesTabContainer = ({
  categories,
  editedValues,
  onCommissionChange,
  canManage,
  isLoading,
  selectedId,
  forcedOpenIds,
  onSelect,
}: TCommissionCategoriesTabContainer) => (
  <CommissionCategoryTree
    categories={categories}
    editedValues={editedValues}
    onCommissionChange={onCommissionChange}
    canManage={canManage}
    isLoading={isLoading}
    selectedId={selectedId}
    forcedOpenIds={forcedOpenIds}
    onSelect={onSelect}
  />
);

export default CommissionCategoriesTabContainer;
